import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";

const AddBanks = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [formdata, setFormData] = useState({
    id: null,
    account_name: "",
    bank_name: "",
    branch_name: "",
    account_number: "",
    bank_code: "",
    is_active: false
  });

  const onSave = () => {
    if (
      formdata.bank_name &&
      formdata.branch_name &&
      formdata.account_number &&
      formdata.bank_code &&
      formdata.account_name
    ) {
      setError(false);
      setLoading(true);
      const pUrl = id ? API_URL.BANKS_SAVE : API_URL.BANKS_SAVE;
      axios.post(pUrl, formdata).then((res) => {
        if (res.data.status === 1) {
          let message = id
            ? "Bank Updated Successfully."
            : "Bank Created Successfully.";
          toast.success(message, { autoClose: 3000, position: "top-right" });
          setLoading(false);
          navigate("/settings/banks");
        }
      })
        .finally(() => {
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const onEdit = () => {
    axios.post(API_URL.BANKS_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: res.data.data.id,
          is_active: (res.data.data.is_active) ? true : false,
          bank_name: res.data.data.bank_name ? res.data.data.bank_name : "",
          branch_name: res.data.data.branch_name
            ? res.data.data.branch_name
            : "",
          account_number: res.data.data.account_number
            ? res.data.data.account_number
            : "",
          bank_code: res.data.data.bank_code ? res.data.data.bank_code : "",
          account_name: res.data.data.account_name
            ? res.data.data.account_name
            : "",
        });
      }
    });
  };

  const isRequiredField = (key) => {
    return isError && !formdata[key];
  };

  useEffect(() => {
    id && onEdit();
  }, [id]);
  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} Banks</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/settings/banks"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Account Name<span className="required-star">*</span></label>
                      <input
                        type="text"
                        name="account_name"
                        value={formdata.account_name}
                        className={
                          isRequiredField("account_name")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="account_name"
                        onChange={(event) => {
                          setFormData({
                            ...formdata,
                            account_name: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Bank name<span className="required-star">*</span></label>
                      <input
                        type="text"
                        name="bank_name"
                        value={formdata.bank_name}
                        className={
                          isRequiredField("bank_name")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="bank_name"
                        onChange={(event) => {
                          setFormData({
                            ...formdata,
                            bank_name: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Branch Name<span className="required-star">*</span></label>
                      <input
                        type="text"
                        name="branch_name"
                        value={formdata.branch_name}
                        className={
                          isRequiredField("branch_name")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="branch_name"
                        onChange={(event) => {
                          setFormData({
                            ...formdata,
                            branch_name: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Account Number<span className="required-star">*</span></label>
                      <input
                        type="text"
                        name="account_number"
                        value={formdata.account_number}
                        className={
                          isRequiredField("account_number")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="account_number"
                        onChange={(event) => {
                          setFormData({
                            ...formdata,
                            account_number: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Bank Code<span className="required-star">*</span></label>
                      <input
                        type="text"
                        name="bank_code"
                        value={formdata.bank_code}
                        className={
                          isRequiredField("bank_code")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="bank_code"
                        onChange={(event) => {
                          setFormData({
                            ...formdata,
                            bank_code: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label className="d-block">Active</label>
                      <input
                        type="checkbox"
                        name="bank_code"
                        style={{ width: 20, height: 20 }}
                        checked={formdata.is_active}
                        onChange={(event) => {
                          setFormData({
                            ...formdata,
                            is_active: event.target.checked,
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                  <div className="col-md-12">
                    <div className="form-group text-right">
                      <button
                        type="submit"
                        onClick={onSave}
                        disabled={loading}
                        className="btn btn-primary"
                      >
                        {loading ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Watch color={"white"} height={20} width={20} />
                          </div>
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBanks;
